/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetUserDto } from '../dtos/getUserDto.type';

export const userManagement = createActionGroup({
    source: '[Aumico-User-Management] Users',
    events: {
        'get users for admin': emptyProps(),
        'get users for admin success': props<{ payload: GetUserDto[] }>(),
        'get users for admin failure': props<{ payload: HttpErrorResponse }>(),
        'block user': props<{ payload: string }>(),
        'block user success': props<{ payload: string }>(),
        'block user failure': props<{ payload: HttpErrorResponse }>(),
        'unblock user': props<{ payload: string }>(),
        'unblock user success': props<{ payload: string }>(),
        'unblock user failure': props<{ payload: HttpErrorResponse }>(),
        'promote user to admin': props<{ payload: string }>(),
        'promote user to admin success': props<{ payload: string }>(),
        'promote user to admin failure': props<{ payload: HttpErrorResponse }>(),
        'demote user from admin': props<{ payload: string }>(),
        'demote user from admin success': props<{ payload: string }>(),
        'demote user from admin failure': props<{ payload: HttpErrorResponse }>(),
        'change user role': props<{ userId: string; newRole: string }>(),
        'change user role success': props<{ payload: GetUserDto }>(),
        'change user role failure': props<{ payload: HttpErrorResponse }>(),
        'delete user': props<{ payload: string }>(),
        'delete user success': props<{ payload: string }>(),
        'delete user failure': props<{ payload: HttpErrorResponse }>(),
    },
});

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
